import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, NgForm, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonModule } from '@angular/common';
import { SharedLavorazioniModule } from '../../main-home/pages/lavorazioni/modules/shared-lavorazioni/shared-lavorazioni.module';
import { InViewportDirective } from '../../../directives/in-viewport.directive';
import { Router } from '@angular/router';
import { RecaptchaService } from '../../../services/recaptcha.service';

@Component({
    selector: 'app-login',
    imports: [CommonModule, InViewportDirective, ReactiveFormsModule,
        SharedLavorazioniModule],
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss'
})
export class LoginComponent {

  invalidCredentials = false;
  submitted = false;
  toggled: boolean = true;
  type: string = 'password'

  private authenticationService: AuthenticationService = inject(AuthenticationService);
  private router: Router = inject(Router);
  private recaptchaService = inject(RecaptchaService);


  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required, Validators.minLength(6)]),
  })

  constructor() { }


  async login() {
    this.submitted = true;
    if (this.loginForm.valid) {
      const email = this.loginForm.get('email')?.value;
      const password = this.loginForm.get('password')?.value;
      if (email && email.length > 0 && password && password.length > 0) {
        try {
          // 1. Esegui reCAPTCHA per ottenere il token
          // L'azione 'login' è un identificatore per Google per analizzare il traffico.
          const recaptchaToken = await this.recaptchaService.executeRecaptcha('login');
          // console.log('reCAPTCHA Token:', recaptchaToken); // Per debugging
          // 2. Passa il token reCAPTCHA al servizio di autenticazione
          this.authenticationService.loginServer(email, password, recaptchaToken);
        } catch (error) {
          // console.error('Errore durante l\'esecuzione di reCAPTCHA:', error);
          // Gestisci l'errore di reCAPTCHA. Potresti mostrare un messaggio all'utente.
          this.invalidCredentials = true; // O un messaggio di errore più specifico
        }
      }
    } else {
      this.invalidCredentials = true;
    }
  }
  forgotPassword(event?: Event) {
    event?.preventDefault();
    this.router.navigate(['forgot-password']);
  }
  seePassword() {
    if (this.type === 'password') {
      this.type = 'text';
      this.toggled = false;
    }
    else {
      this.type = 'password';
      this.toggled = true;
    }
  }

  onEnter(event: any): void {
    // Impedisci la propagazione dell'evento "Enter"
    event.preventDefault();
  }
}
